module.exports = __webpack_public_path__ + "media/src/assets/images/footer-contact-bg-43f6c9ccdb5288b220245577f124cb98.jpg";